import { render, staticRenderFns } from "./caseSetting.vue?vue&type=template&id=13dd2093&scoped=true&"
import script from "./caseSetting.vue?vue&type=script&lang=js&"
export * from "./caseSetting.vue?vue&type=script&lang=js&"
import style0 from "./caseSetting.vue?vue&type=style&index=0&id=13dd2093&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dd2093",
  null
  
)

export default component.exports